// React
import React, { useEffect, useState } from "react";
// Router
import { NavLink, useLocation } from "react-router-dom";

// The super admin's money screens, under one Finance item that opens on click.
export const FINANCE_LINKS = [
  { to: "/load-funds", label: "Load Funds" },
  { to: "/credit-memos", label: "Available Credit Memo" },
  { to: "/revenue", label: "Revenue" },
  { to: "/stats-dashboard", label: "Stats Dashboard" },
  { to: "/prepay-taxes", label: "Prepay Taxes" },
];

/**
 * @param {*} props styles: the menu bar's CSS module
 * @return {*} {React.ReactElement}
 */
const FinanceMenu: React.FC<{ styles: any }> = ({ styles }) => {
  const location = useLocation();
  const onFinancePage = FINANCE_LINKS.some((link) => location.pathname.startsWith(link.to));
  const [open, setOpen] = useState(onFinancePage);

  // Opening one of its screens some other way opens the group too.
  useEffect(() => {
    if (onFinancePage) setOpen(true);
  }, [onFinancePage]);

  const toggle = (event: React.SyntheticEvent) => {
    event.preventDefault();
    setOpen(!open);
  };

  return (
    <>
      <a
        href="#finance"
        role="button"
        aria-expanded={open}
        className={`${styles.linkContainer} ${onFinancePage && !open ? styles.active : ""}`}
        onClick={toggle}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") toggle(event);
        }}
      >
        <div className={styles.linkItem}>Finance</div>
        <div className={styles.linkItem}>{open ? "-" : "+"}</div>
      </a>
      {open &&
        FINANCE_LINKS.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            activeClassName={styles.active}
            className={`${styles.linkContainer} ${styles.subLink}`}
          >
            <div className={styles.linkItem}>{link.label}</div>
          </NavLink>
        ))}
    </>
  );
};

export default FinanceMenu;
